import { useEffect, useState } from "react";
import axios from "axios";

// Loads the PDF as a private blob so it can be previewed without allowing the API to be framed.
export const ReceiptPdfFrame = ({ url }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let objectUrl;
    axios.get(url, { responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })); setSrc(objectUrl); })
      .catch(() => setSrc(""));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [url]);
  if (src === null) return <p className="p-6 text-sm text-[#64748B]" data-testid="receipt-pdf-loading">Loading receipt…</p>;
  if (!src) return <p className="p-6 text-sm text-red-700" data-testid="receipt-pdf-error">Could not load this receipt.</p>;
  return <iframe src={src} title="Receipt PDF" className="w-full h-[80vh] bg-white" data-testid="receipt-pdf-iframe" />;
};
